export default __webpack_public_path__ + "static/media/Ghostbusters.82ea8a5f.mp3";